import { render, staticRenderFns } from "./FormFormBlock.vue?vue&type=template&id=6003ff00&"
import script from "./FormFormBlock.vue?vue&type=script&lang=js&"
export * from "./FormFormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormFormBlock.vue"
export default component.exports